<template>
  <base-filter-expander
    :title="$t('search.select-your-model')"
    :is-valid="!!isValid"
  >
    <base-tiles-grid>
      <base-tile
        v-for="model in models"
        :id="model.id"
        :key="model.id"
        :image="model.image"
        :text="model.text"
        :is-active="modelIsActive(model.id)"
        @store-update="updateModelsInState($event)"
      />
    </base-tiles-grid>
  </base-filter-expander>
</template>

<script>
import BaseFilterExpander from "@/components/ui/BaseFilterExpander/BaseFilterExpander.vue";
import BaseTilesGrid from "@/components/ui/BaseTilesGrid/BaseTilesGrid.vue";
import BaseTile from "@/components/ui/BaseTile/BaseTile.vue";
import models from "@/constants/models";
import { ADD_MODEL, CLEAR, REMOVE_MODEL } from "@/store/mutationTypes";
import { GET_DATA_FROM_API } from "@/store/actionTypes";
import { mapState } from "vuex";
import { moveTo } from "@/utils";

export default {
  name: "ModelSelect",
  components: {
    BaseFilterExpander,
    BaseTilesGrid,
    BaseTile
  },
  computed: {
    ...mapState(["search"]),
    models() {
      return models;
    },
    isValid() {
      return this.search.models.length;
    }
  },
  mounted() {
    this.$store.commit(CLEAR);
  },
  methods: {
    updateModelsInState(model) {
      const action = model.action == "add" ? ADD_MODEL : REMOVE_MODEL;
      this.$store.commit(action, model.id);
      this.$store.dispatch(GET_DATA_FROM_API);
      model.action == "add" &&
        moveTo("second-section-anchor", { smooth: true });
    },
    modelIsActive(model) {
      return this.search.models.includes(model);
    }
  }
};
</script>
